import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BulkProcessorType = /*#__PURE__*/function (BulkProcessorType) {
  BulkProcessorType[BulkProcessorType["BULK_PROCESSOR_TYPE_INVALID"] = 0] = "BULK_PROCESSOR_TYPE_INVALID";
  BulkProcessorType[BulkProcessorType["BULK_PROCESSOR_TYPE_IMPORT_USERS"] = 1] = "BULK_PROCESSOR_TYPE_IMPORT_USERS";
  BulkProcessorType[BulkProcessorType["BULK_PROCESSOR_TYPE_SCHEDULE_CAMPAIGN"] = 2] = "BULK_PROCESSOR_TYPE_SCHEDULE_CAMPAIGN";
  return BulkProcessorType;
}(BulkProcessorType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DateDefault = /*#__PURE__*/function (DateDefault) {
  DateDefault[DateDefault["DATE_DEFAULT_INVALID"] = 0] = "DATE_DEFAULT_INVALID";
  DateDefault[DateDefault["DATE_DEFAULT_TODAY"] = 1] = "DATE_DEFAULT_TODAY";
  DateDefault[DateDefault["DATE_DEFAULT_YESTERDAY"] = 2] = "DATE_DEFAULT_YESTERDAY";
  DateDefault[DateDefault["DATE_DEFAULT_TOMORROW"] = 3] = "DATE_DEFAULT_TOMORROW";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_WEEK"] = 4] = "DATE_DEFAULT_THIS_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_WEEK"] = 5] = "DATE_DEFAULT_LAST_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_WEEK"] = 6] = "DATE_DEFAULT_NEXT_WEEK";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_MONTH"] = 7] = "DATE_DEFAULT_THIS_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_MONTH"] = 8] = "DATE_DEFAULT_LAST_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_MONTH"] = 9] = "DATE_DEFAULT_NEXT_MONTH";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_QUARTER"] = 10] = "DATE_DEFAULT_THIS_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_QUARTER"] = 11] = "DATE_DEFAULT_LAST_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_QUARTER"] = 12] = "DATE_DEFAULT_NEXT_QUARTER";
  DateDefault[DateDefault["DATE_DEFAULT_THIS_YEAR"] = 13] = "DATE_DEFAULT_THIS_YEAR";
  DateDefault[DateDefault["DATE_DEFAULT_LAST_YEAR"] = 14] = "DATE_DEFAULT_LAST_YEAR";
  DateDefault[DateDefault["DATE_DEFAULT_NEXT_YEAR"] = 15] = "DATE_DEFAULT_NEXT_YEAR";
  return DateDefault;
}(DateDefault || {});
var FilterGroupOperator = /*#__PURE__*/function (FilterGroupOperator) {
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_INVALID"] = 0] = "FILTER_GROUP_OPERATOR_INVALID";
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_AND"] = 1] = "FILTER_GROUP_OPERATOR_AND";
  FilterGroupOperator[FilterGroupOperator["FILTER_GROUP_OPERATOR_OR"] = 2] = "FILTER_GROUP_OPERATOR_OR";
  return FilterGroupOperator;
}(FilterGroupOperator || {});
var FilterOperator = /*#__PURE__*/function (FilterOperator) {
  FilterOperator[FilterOperator["FILTER_OPERATOR_INVALID"] = 0] = "FILTER_OPERATOR_INVALID";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_EMPTY"] = 1] = "FILTER_OPERATOR_IS_EMPTY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_EMPTY"] = 2] = "FILTER_OPERATOR_IS_NOT_EMPTY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS"] = 3] = "FILTER_OPERATOR_IS";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT"] = 4] = "FILTER_OPERATOR_IS_NOT";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_ANY"] = 5] = "FILTER_OPERATOR_IS_ANY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_ANY"] = 6] = "FILTER_OPERATOR_IS_NOT_ANY";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_ALL"] = 7] = "FILTER_OPERATOR_IS_ALL";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_ALL"] = 8] = "FILTER_OPERATOR_IS_NOT_ALL";
  FilterOperator[FilterOperator["FILTER_OPERATOR_CONTAINS"] = 9] = "FILTER_OPERATOR_CONTAINS";
  FilterOperator[FilterOperator["FILTER_OPERATOR_DOES_NOT_CONTAIN"] = 10] = "FILTER_OPERATOR_DOES_NOT_CONTAIN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_EQUAL_TO"] = 11] = "FILTER_OPERATOR_IS_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_EQUAL_TO"] = 12] = "FILTER_OPERATOR_IS_NOT_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_GREATER_THAN"] = 13] = "FILTER_OPERATOR_IS_GREATER_THAN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO"] = 14] = "FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_LESS_THAN"] = 15] = "FILTER_OPERATOR_IS_LESS_THAN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO"] = 16] = "FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BEFORE"] = 17] = "FILTER_OPERATOR_IS_BEFORE";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BEFORE_OR_ON"] = 18] = "FILTER_OPERATOR_IS_BEFORE_OR_ON";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_AFTER"] = 19] = "FILTER_OPERATOR_IS_AFTER";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_AFTER_OR_ON"] = 20] = "FILTER_OPERATOR_IS_AFTER_OR_ON";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_BETWEEN"] = 21] = "FILTER_OPERATOR_IS_BETWEEN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_BETWEEN"] = 22] = "FILTER_OPERATOR_IS_NOT_BETWEEN";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_VALID"] = 23] = "FILTER_OPERATOR_IS_VALID";
  FilterOperator[FilterOperator["FILTER_OPERATOR_IS_NOT_VALID"] = 24] = "FILTER_OPERATOR_IS_NOT_VALID";
  return FilterOperator;
}(FilterOperator || {});
var FilterType = /*#__PURE__*/function (FilterType) {
  FilterType[FilterType["FILTER_TYPE_INVALID"] = 0] = "FILTER_TYPE_INVALID";
  FilterType[FilterType["FILTER_TYPE_STRING"] = 1] = "FILTER_TYPE_STRING";
  FilterType[FilterType["FILTER_TYPE_INTEGER"] = 2] = "FILTER_TYPE_INTEGER";
  FilterType[FilterType["FILTER_TYPE_DATE"] = 3] = "FILTER_TYPE_DATE";
  FilterType[FilterType["FILTER_TYPE_FLOAT"] = 4] = "FILTER_TYPE_FLOAT";
  FilterType[FilterType["FILTER_TYPE_BOOLEAN"] = 5] = "FILTER_TYPE_BOOLEAN";
  FilterType[FilterType["FILTER_TYPE_TAG"] = 6] = "FILTER_TYPE_TAG";
  FilterType[FilterType["FILTER_TYPE_PHONE"] = 8] = "FILTER_TYPE_PHONE";
  return FilterType;
}(FilterType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ListType = /*#__PURE__*/function (ListType) {
  ListType[ListType["LIST_TYPE_INVALID"] = 0] = "LIST_TYPE_INVALID";
  ListType[ListType["LIST_TYPE_STATIC"] = 1] = "LIST_TYPE_STATIC";
  ListType[ListType["LIST_TYPE_DYNAMIC"] = 2] = "LIST_TYPE_DYNAMIC";
  return ListType;
}(ListType || {});
// *********************************

function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkProcessorDetails {
  static fromProto(proto) {
    let m = new BulkProcessorDetails();
    m = Object.assign(m, proto);
    if (proto.csvFile) {
      m.csvFile = BulkProcessorDetailsCSVFile.fromProto(proto.csvFile);
    }
    if (proto.userList) {
      m.userList = BulkProcessorDetailsUserList.fromProto(proto.userList);
    }
    if (proto.importUsers) {
      m.importUsers = BulkProcessorDetailsImportUsers.fromProto(proto.importUsers);
    }
    if (proto.scheduleCampaign) {
      m.scheduleCampaign = BulkProcessorDetailsScheduleCampaign.fromProto(proto.scheduleCampaign);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.csvFile !== 'undefined' && this.csvFile !== null) {
      toReturn['csvFile'] = 'toApiJson' in this.csvFile ? this.csvFile.toApiJson() : this.csvFile;
    }
    if (typeof this.userList !== 'undefined' && this.userList !== null) {
      toReturn['userList'] = 'toApiJson' in this.userList ? this.userList.toApiJson() : this.userList;
    }
    if (typeof this.importUsers !== 'undefined' && this.importUsers !== null) {
      toReturn['importUsers'] = 'toApiJson' in this.importUsers ? this.importUsers.toApiJson() : this.importUsers;
    }
    if (typeof this.scheduleCampaign !== 'undefined' && this.scheduleCampaign !== null) {
      toReturn['scheduleCampaign'] = 'toApiJson' in this.scheduleCampaign ? this.scheduleCampaign.toApiJson() : this.scheduleCampaign;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsCSVFile {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsCSVFile();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsImportUsers {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsImportUsers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userListId !== 'undefined') {
      toReturn['userListId'] = this.userListId;
    }
    if (typeof this.updateUsers !== 'undefined') {
      toReturn['updateUsers'] = this.updateUsers;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsScheduleCampaign {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsScheduleCampaign();
    m = Object.assign(m, proto);
    if (proto.scheduleOn) {
      m.scheduleOn = new Date(proto.scheduleOn);
    }
    if (proto.sender) {
      m.sender = BulkProcessorDetailsScheduleCampaignSender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.scheduleOn !== 'undefined' && this.scheduleOn !== null) {
      toReturn['scheduleOn'] = 'toApiJson' in this.scheduleOn ? this.scheduleOn.toApiJson() : this.scheduleOn;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.defaultAccountGroupId !== 'undefined') {
      toReturn['defaultAccountGroupId'] = this.defaultAccountGroupId;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsScheduleCampaignSender {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsScheduleCampaignSender();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsUserList {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsUserList();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userListId !== 'undefined') {
      toReturn['userListId'] = this.userListId;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActionListKey {
  static fromProto(proto) {
    let m = new ActionListKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class AddActionListItemsRequest {
  static fromProto(proto) {
    let m = new AddActionListItemsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    return toReturn;
  }
}
class BulkActionInstanceStatus {
  static fromProto(proto) {
    let m = new BulkActionInstanceStatus();
    m = Object.assign(m, proto);
    if (proto.processedItems) {
      m.processedItems = parseInt(proto.processedItems, 10);
    }
    if (proto.totalItems) {
      m.totalItems = parseInt(proto.totalItems, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instanceId !== 'undefined') {
      toReturn['instanceId'] = this.instanceId;
    }
    if (typeof this.processedItems !== 'undefined') {
      toReturn['processedItems'] = this.processedItems;
    }
    if (typeof this.totalItems !== 'undefined') {
      toReturn['totalItems'] = this.totalItems;
    }
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    if (typeof this.actionDisplayName !== 'undefined') {
      toReturn['actionDisplayName'] = this.actionDisplayName;
    }
    if (typeof this.isFinalized !== 'undefined') {
      toReturn['isFinalized'] = this.isFinalized;
    }
    return toReturn;
  }
}
class ComputeActionListIDsRequest {
  static fromProto(proto) {
    let m = new ComputeActionListIDsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.names !== 'undefined') {
      toReturn['names'] = this.names;
    }
    return toReturn;
  }
}
class ComputeActionListIDsResponse {
  static fromProto(proto) {
    let m = new ComputeActionListIDsResponse();
    m = Object.assign(m, proto);
    if (proto.nameIdMapping) {
      m.nameIdMapping = Object.keys(proto.nameIdMapping).reduce((obj, k) => {
        obj[k] = proto.nameIdMapping[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nameIdMapping !== 'undefined' && this.nameIdMapping !== null) {
      toReturn['nameIdMapping'] = 'toApiJson' in this.nameIdMapping ? this.nameIdMapping.toApiJson() : this.nameIdMapping;
    }
    return toReturn;
  }
}
class CreateActionListRequest {
  static fromProto(proto) {
    let m = new CreateActionListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class CreateActionListResponse {
  static fromProto(proto) {
    let m = new CreateActionListResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class DeleteActionListRequest {
  static fromProto(proto) {
    let m = new DeleteActionListRequest();
    m = Object.assign(m, proto);
    if (proto.actionListKey) {
      m.actionListKey = ActionListKey.fromProto(proto.actionListKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListKey !== 'undefined' && this.actionListKey !== null) {
      toReturn['actionListKey'] = 'toApiJson' in this.actionListKey ? this.actionListKey.toApiJson() : this.actionListKey;
    }
    return toReturn;
  }
}
class GenerateUploadSignedURLRequest {
  static fromProto(proto) {
    let m = new GenerateUploadSignedURLRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fileName !== 'undefined') {
      toReturn['fileName'] = this.fileName;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    return toReturn;
  }
}
class GenerateUploadSignedURLResponse {
  static fromProto(proto) {
    let m = new GenerateUploadSignedURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.signedUrl !== 'undefined') {
      toReturn['signedUrl'] = this.signedUrl;
    }
    return toReturn;
  }
}
class GetActionListItemIDsRequest {
  static fromProto(proto) {
    let m = new GetActionListItemIDsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class GetActionListItemIDsResponse {
  static fromProto(proto) {
    let m = new GetActionListItemIDsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    return toReturn;
  }
}
class GetBulkActionInstanceItemIDsRequest {
  static fromProto(proto) {
    let m = new GetBulkActionInstanceItemIDsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instanceId !== 'undefined') {
      toReturn['instanceId'] = this.instanceId;
    }
    return toReturn;
  }
}
class GetBulkActionInstanceItemIDsResponse {
  static fromProto(proto) {
    let m = new GetBulkActionInstanceItemIDsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bulkActionItemIds !== 'undefined') {
      toReturn['bulkActionItemIds'] = this.bulkActionItemIds;
    }
    return toReturn;
  }
}
class InitiateBulkActionRequest {
  static fromProto(proto) {
    let m = new InitiateBulkActionRequest();
    m = Object.assign(m, proto);
    if (proto.actionListKey) {
      m.actionListKey = ActionListKey.fromProto(proto.actionListKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListKey !== 'undefined' && this.actionListKey !== null) {
      toReturn['actionListKey'] = 'toApiJson' in this.actionListKey ? this.actionListKey.toApiJson() : this.actionListKey;
    }
    if (typeof this.instanceId !== 'undefined') {
      toReturn['instanceId'] = this.instanceId;
    }
    if (typeof this.hasFinalizeStep !== 'undefined') {
      toReturn['hasFinalizeStep'] = this.hasFinalizeStep;
    }
    return toReturn;
  }
}
class InitiateBulkProcessorRequest {
  static fromProto(proto) {
    let m = new InitiateBulkProcessorRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$7(BulkProcessorType, proto.type);
    }
    if (proto.details) {
      m.details = BulkProcessorDetails.fromProto(proto.details);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.details !== 'undefined' && this.details !== null) {
      toReturn['details'] = 'toApiJson' in this.details ? this.details.toApiJson() : this.details;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class InitiateBulkProcessorResponse {
  static fromProto(proto) {
    let m = new InitiateBulkProcessorResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListBulkActionStatusesForActionListRequest {
  static fromProto(proto) {
    let m = new ListBulkActionStatusesForActionListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class ListBulkActionStatusesForActionListResponse {
  static fromProto(proto) {
    let m = new ListBulkActionStatusesForActionListResponse();
    m = Object.assign(m, proto);
    if (proto.instances) {
      m.instances = proto.instances.map(BulkActionInstanceStatus.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instances !== 'undefined' && this.instances !== null) {
      toReturn['instances'] = 'toApiJson' in this.instances ? this.instances.toApiJson() : this.instances;
    }
    return toReturn;
  }
}
class ComputeActionListIDsResponseNameIdMappingEntry {
  static fromProto(proto) {
    let m = new ComputeActionListIDsResponseNameIdMappingEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class RemoveActionListItemsRequest {
  static fromProto(proto) {
    let m = new RemoveActionListItemsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    return toReturn;
  }
}
class ValidateFileRequest {
  static fromProto(proto) {
    let m = new ValidateFileRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$7(BulkProcessorType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ValidateFileResponse {
  static fromProto(proto) {
    let m = new ValidateFileResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActionList {
  static fromProto(proto) {
    let m = new ActionList();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.legacyHistoryId !== 'undefined') {
      toReturn['legacyHistoryId'] = this.legacyHistoryId;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkActionInstance {
  static fromProto(proto) {
    let m = new BulkActionInstance();
    m = Object.assign(m, proto);
    if (proto.initiated) {
      m.initiated = new Date(proto.initiated);
    }
    if (proto.completed) {
      m.completed = new Date(proto.completed);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instanceId !== 'undefined') {
      toReturn['instanceId'] = this.instanceId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.error !== 'undefined') {
      toReturn['error'] = this.error;
    }
    if (typeof this.initiated !== 'undefined' && this.initiated !== null) {
      toReturn['initiated'] = 'toApiJson' in this.initiated ? this.initiated.toApiJson() : this.initiated;
    }
    if (typeof this.completed !== 'undefined' && this.completed !== null) {
      toReturn['completed'] = 'toApiJson' in this.completed ? this.completed.toApiJson() : this.completed;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Filter {
  static fromProto(proto) {
    let m = new Filter();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$4(FilterOperator, proto.operator);
    }
    if (proto.values) {
      m.values = proto.values.map(FilterValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? this.values.toApiJson() : this.values;
    }
    if (typeof this.floatTolerance !== 'undefined') {
      toReturn['floatTolerance'] = this.floatTolerance;
    }
    return toReturn;
  }
}
class FilterGroup {
  static fromProto(proto) {
    let m = new FilterGroup();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$4(FilterGroupOperator, proto.operator);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(Filter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class Phone {
  static fromProto(proto) {
    let m = new Phone();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isoCountryCode !== 'undefined') {
      toReturn['isoCountryCode'] = this.isoCountryCode;
    }
    if (typeof this.nationalNumber !== 'undefined') {
      toReturn['nationalNumber'] = this.nationalNumber;
    }
    if (typeof this.extension !== 'undefined') {
      toReturn['extension'] = this.extension;
    }
    return toReturn;
  }
}
class FilterValue {
  static fromProto(proto) {
    let m = new FilterValue();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.dateDefault) {
      m.dateDefault = enumStringToValue$4(DateDefault, proto.dateDefault);
    }
    if (proto.phone) {
      m.phone = Phone.fromProto(proto.phone);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.boolean !== 'undefined') {
      toReturn['boolean'] = this.boolean;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.float !== 'undefined') {
      toReturn['float'] = this.float;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.dateDefault !== 'undefined') {
      toReturn['dateDefault'] = this.dateDefault;
    }
    if (typeof this.phone !== 'undefined' && this.phone !== null) {
      toReturn['phone'] = 'toApiJson' in this.phone ? this.phone.toApiJson() : this.phone;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateListDefinitionRequest {
  static fromProto(proto) {
    let m = new CreateListDefinitionRequest();
    m = Object.assign(m, proto);
    if (proto.listType) {
      m.listType = enumStringToValue$1(ListType, proto.listType);
    }
    if (proto.filter) {
      m.filter = proto.filter.map(Filter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.resourceType !== 'undefined') {
      toReturn['resourceType'] = this.resourceType;
    }
    if (typeof this.listType !== 'undefined') {
      toReturn['listType'] = this.listType;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CreateListDefinitionResponse {
  static fromProto(proto) {
    let m = new CreateListDefinitionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    return toReturn;
  }
}
class DeleteListDefinitionRequest {
  static fromProto(proto) {
    let m = new DeleteListDefinitionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    return toReturn;
  }
}
class GetMultiListDefinitionRequest {
  static fromProto(proto) {
    let m = new GetMultiListDefinitionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listIds !== 'undefined') {
      toReturn['listIds'] = this.listIds;
    }
    return toReturn;
  }
}
class GetMultiListDefinitionResponse {
  static fromProto(proto) {
    let m = new GetMultiListDefinitionResponse();
    m = Object.assign(m, proto);
    if (proto.listDefinitions) {
      m.listDefinitions = proto.listDefinitions.map(ListDefinition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listDefinitions !== 'undefined' && this.listDefinitions !== null) {
      toReturn['listDefinitions'] = 'toApiJson' in this.listDefinitions ? this.listDefinitions.toApiJson() : this.listDefinitions;
    }
    return toReturn;
  }
}
class ListDefinition {
  static fromProto(proto) {
    let m = new ListDefinition();
    m = Object.assign(m, proto);
    if (proto.listType) {
      m.listType = enumStringToValue$1(ListType, proto.listType);
    }
    if (proto.filter) {
      m.filter = proto.filter.map(Filter.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.resourceType !== 'undefined') {
      toReturn['resourceType'] = this.resourceType;
    }
    if (typeof this.listType !== 'undefined') {
      toReturn['listType'] = this.listType;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class ListDefinitionsRequest {
  static fromProto(proto) {
    let m = new ListDefinitionsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = FilterGroup.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListDefinitionsResponse {
  static fromProto(proto) {
    let m = new ListDefinitionsResponse();
    m = Object.assign(m, proto);
    if (proto.listDefinitions) {
      m.listDefinitions = proto.listDefinitions.map(ListDefinition.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listDefinitions !== 'undefined' && this.listDefinitions !== null) {
      toReturn['listDefinitions'] = 'toApiJson' in this.listDefinitions ? this.listDefinitions.toApiJson() : this.listDefinitions;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UpdateListDefinitionRequest {
  static fromProto(proto) {
    let m = new UpdateListDefinitionRequest();
    m = Object.assign(m, proto);
    if (proto.filter) {
      m.filter = proto.filter.map(Filter.fromProto);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddMultiStaticItemRequest {
  static fromProto(proto) {
    let m = new AddMultiStaticItemRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    return toReturn;
  }
}
class AddStaticItemRequest {
  static fromProto(proto) {
    let m = new AddStaticItemRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.resourceName !== 'undefined') {
      toReturn['resourceName'] = this.resourceName;
    }
    if (typeof this.resourceUrl !== 'undefined') {
      toReturn['resourceUrl'] = this.resourceUrl;
    }
    return toReturn;
  }
}
class BulkAddStaticItemsRequest {
  static fromProto(proto) {
    let m = new BulkAddStaticItemsRequest();
    m = Object.assign(m, proto);
    if (proto.search) {
      m.search = ObjectSearch.fromProto(proto.search);
    }
    if (proto.filters) {
      m.filters = FilterGroup.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.search !== 'undefined' && this.search !== null) {
      toReturn['search'] = 'toApiJson' in this.search ? this.search.toApiJson() : this.search;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class DeleteStaticItemRequest {
  static fromProto(proto) {
    let m = new DeleteStaticItemRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    return toReturn;
  }
}
class ListItem {
  static fromProto(proto) {
    let m = new ListItem();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.resourceName !== 'undefined') {
      toReturn['resourceName'] = this.resourceName;
    }
    if (typeof this.resourceUrl !== 'undefined') {
      toReturn['resourceUrl'] = this.resourceUrl;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class ListItemsRequest {
  static fromProto(proto) {
    let m = new ListItemsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListItemsResponse {
  static fromProto(proto) {
    let m = new ListItemsResponse();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(ListItem.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ObjectSearch {
  static fromProto(proto) {
    let m = new ObjectSearch();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class StartManualAutomationsRequestStartAutomationPayload {
  static fromProto(proto) {
    let m = new StartManualAutomationsRequestStartAutomationPayload();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    return toReturn;
  }
}
class StartManualAutomationsRequest {
  static fromProto(proto) {
    let m = new StartManualAutomationsRequest();
    m = Object.assign(m, proto);
    if (proto.payload) {
      m.payload = StartManualAutomationsRequestStartAutomationPayload.fromProto(proto.payload);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.payload !== 'undefined' && this.payload !== null) {
      toReturn['payload'] = 'toApiJson' in this.payload ? this.payload.toApiJson() : this.payload;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'bulk-actions-api.vendasta-local.com',
  'test': '',
  'demo': 'bulk-actions-demo.apigateway.co',
  'prod': 'bulk-actions-prod.apigateway.co',
  'production': 'bulk-actions-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ActionListsApiService = /*#__PURE__*/(() => {
  class ActionListsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createActionList(r) {
      const request = r.toApiJson ? r : new CreateActionListRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/CreateActionList", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateActionListResponse.fromProto(resp)));
    }
    deleteActionList(r) {
      const request = r.toApiJson ? r : new DeleteActionListRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/DeleteActionList", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addActionListItems(r) {
      const request = r.toApiJson ? r : new AddActionListItemsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/AddActionListItems", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeActionListItems(r) {
      const request = r.toApiJson ? r : new RemoveActionListItemsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/RemoveActionListItems", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getActionListItemIDs(r) {
      const request = r.toApiJson ? r : new GetActionListItemIDsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/GetActionListItemIDs", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetActionListItemIDsResponse.fromProto(resp)));
    }
    computeActionListId(r) {
      const request = r.toApiJson ? r : new ComputeActionListIDsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/ComputeActionListID", request.toApiJson(), this.apiOptions()).pipe(map(resp => ComputeActionListIDsResponse.fromProto(resp)));
    }
  }
  ActionListsApiService.ɵfac = function ActionListsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ActionListsApiService)();
  };
  ActionListsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ActionListsApiService,
    factory: ActionListsApiService.ɵfac,
    providedIn: 'root'
  });
  return ActionListsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BulkActionStatusApiService = /*#__PURE__*/(() => {
  class BulkActionStatusApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listBulkActionStatusesForActionList(r) {
      const request = r.toApiJson ? r : new ListBulkActionStatusesForActionListRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkActionStatus/ListBulkActionStatusesForActionList", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBulkActionStatusesForActionListResponse.fromProto(resp)));
    }
  }
  BulkActionStatusApiService.ɵfac = function BulkActionStatusApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BulkActionStatusApiService)();
  };
  BulkActionStatusApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BulkActionStatusApiService,
    factory: BulkActionStatusApiService.ɵfac,
    providedIn: 'root'
  });
  return BulkActionStatusApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BulkActionsApiService = /*#__PURE__*/(() => {
  class BulkActionsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    initiateBulkAction(r) {
      const request = r.toApiJson ? r : new InitiateBulkActionRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkActions/InitiateBulkAction", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getBulkActionInstanceItemIDs(r) {
      const request = r.toApiJson ? r : new GetBulkActionInstanceItemIDsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkActions/GetBulkActionInstanceItemIDs", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBulkActionInstanceItemIDsResponse.fromProto(resp)));
    }
  }
  BulkActionsApiService.ɵfac = function BulkActionsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BulkActionsApiService)();
  };
  BulkActionsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BulkActionsApiService,
    factory: BulkActionsApiService.ɵfac,
    providedIn: 'root'
  });
  return BulkActionsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BulkProcessorApiService = /*#__PURE__*/(() => {
  class BulkProcessorApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generateUploadSignedUrl(r) {
      const request = r.toApiJson ? r : new GenerateUploadSignedURLRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkProcessor/GenerateUploadSignedURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateUploadSignedURLResponse.fromProto(resp)));
    }
    initiateBulkProcessor(r) {
      const request = r.toApiJson ? r : new InitiateBulkProcessorRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkProcessor/InitiateBulkProcessor", request.toApiJson(), this.apiOptions()).pipe(map(resp => InitiateBulkProcessorResponse.fromProto(resp)));
    }
    validateFile(r) {
      const request = r.toApiJson ? r : new ValidateFileRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkProcessor/ValidateFile", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateFileResponse.fromProto(resp)));
    }
  }
  BulkProcessorApiService.ɵfac = function BulkProcessorApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BulkProcessorApiService)();
  };
  BulkProcessorApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BulkProcessorApiService,
    factory: BulkProcessorApiService.ɵfac,
    providedIn: 'root'
  });
  return BulkProcessorApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ListDefinitionsApiService = /*#__PURE__*/(() => {
  class ListDefinitionsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listDefinitions(r) {
      const request = r.toApiJson ? r : new ListDefinitionsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListDefinitionsService/ListDefinitions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDefinitionsResponse.fromProto(resp)));
    }
    createListDefinition(r) {
      const request = r.toApiJson ? r : new CreateListDefinitionRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListDefinitionsService/CreateListDefinition", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateListDefinitionResponse.fromProto(resp)));
    }
    updateListDefinition(r) {
      const request = r.toApiJson ? r : new UpdateListDefinitionRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListDefinitionsService/UpdateListDefinition", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiListDefinition(r) {
      const request = r.toApiJson ? r : new GetMultiListDefinitionRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListDefinitionsService/GetMultiListDefinition", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiListDefinitionResponse.fromProto(resp)));
    }
    deleteListDefinition(r) {
      const request = r.toApiJson ? r : new DeleteListDefinitionRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListDefinitionsService/DeleteListDefinition", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ListDefinitionsApiService.ɵfac = function ListDefinitionsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListDefinitionsApiService)();
  };
  ListDefinitionsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListDefinitionsApiService,
    factory: ListDefinitionsApiService.ɵfac,
    providedIn: 'root'
  });
  return ListDefinitionsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ListItemsApiService = /*#__PURE__*/(() => {
  class ListItemsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    addMultiStaticItem(r) {
      const request = r.toApiJson ? r : new AddMultiStaticItemRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListItemsService/AddMultiStaticItem", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkAddStaticItems(r) {
      const request = r.toApiJson ? r : new BulkAddStaticItemsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListItemsService/BulkAddStaticItems", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteStaticItem(r) {
      const request = r.toApiJson ? r : new DeleteStaticItemRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListItemsService/DeleteStaticItem", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listItems(r) {
      const request = r.toApiJson ? r : new ListItemsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListItemsService/ListItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListItemsResponse.fromProto(resp)));
    }
    startManualAutomations(r) {
      const request = r.toApiJson ? r : new StartManualAutomationsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v2.ListItemsService/StartManualAutomations", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ListItemsApiService.ɵfac = function ListItemsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListItemsApiService)();
  };
  ListItemsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListItemsApiService,
    factory: ListItemsApiService.ɵfac,
    providedIn: 'root'
  });
  return ListItemsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ActionListsSdkService = /*#__PURE__*/(() => {
  class ActionListsSdkService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    getItemIDs(partnerId, marketId, actionListId) {
      return this.delegate.getActionListItemIDs({
        partnerId: partnerId,
        marketId: marketId,
        actionListId: actionListId
      }).pipe(map(resp => resp.itemIds));
    }
  }
  ActionListsSdkService.ɵfac = function ActionListsSdkService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ActionListsSdkService)(i0.ɵɵinject(ActionListsApiService));
  };
  ActionListsSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ActionListsSdkService,
    factory: ActionListsSdkService.ɵfac,
    providedIn: 'root'
  });
  return ActionListsSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BulkProcessorSdkService = /*#__PURE__*/(() => {
  class BulkProcessorSdkService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    generateUploadSignedUrl(fileName, contentType) {
      return this.delegate.generateUploadSignedUrl({
        fileName,
        contentType
      }).pipe(map(resp => resp.signedUrl));
    }
    initiateImportUsers(partnerId, fileUrl, userListId, updateUsers) {
      const req = {
        type: BulkProcessorType.BULK_PROCESSOR_TYPE_IMPORT_USERS,
        partnerId: partnerId,
        details: {
          csvFile: {
            fileUrl: fileUrl
          },
          importUsers: {
            userListId: userListId,
            updateUsers: updateUsers
          }
        }
      };
      return this.delegate.initiateBulkProcessor(req).pipe(map(resp => resp.id));
    }
    scheduleCampaign(partnerId, userListId, campaignId, scheduleOn, defaultAccountGroupId, email, name) {
      const req = {
        type: BulkProcessorType.BULK_PROCESSOR_TYPE_SCHEDULE_CAMPAIGN,
        partnerId: partnerId,
        details: {
          userList: {
            userListId: userListId
          },
          scheduleCampaign: {
            campaignId: campaignId,
            scheduleOn: scheduleOn,
            defaultAccountGroupId: defaultAccountGroupId,
            sender: {
              email: email,
              name: name
            }
          }
        }
      };
      return this.delegate.initiateBulkProcessor(req).pipe(map(resp => resp.id));
    }
    validateImportUserFile(fileUrl, partnerId) {
      const req = {
        type: BulkProcessorType.BULK_PROCESSOR_TYPE_IMPORT_USERS,
        fileUrl: fileUrl,
        partnerId: partnerId
      };
      return this.delegate.validateFile(req).pipe(map(res => res.errors || []));
    }
  }
  BulkProcessorSdkService.ɵfac = function BulkProcessorSdkService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BulkProcessorSdkService)(i0.ɵɵinject(BulkProcessorApiService));
  };
  BulkProcessorSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BulkProcessorSdkService,
    factory: BulkProcessorSdkService.ɵfac,
    providedIn: 'root'
  });
  return BulkProcessorSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BulkActionsSdkStatusService = /*#__PURE__*/(() => {
  class BulkActionsSdkStatusService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    list(partnerId, marketId, actionListId) {
      const req = new ListBulkActionStatusesForActionListRequest({
        partnerId: partnerId,
        marketId: marketId,
        actionListId: actionListId
      });
      return this.delegate.listBulkActionStatusesForActionList(req).pipe(map(r => fillMissingValues(r.instances)));
    }
  }
  BulkActionsSdkStatusService.ɵfac = function BulkActionsSdkStatusService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BulkActionsSdkStatusService)(i0.ɵɵinject(BulkActionStatusApiService));
  };
  BulkActionsSdkStatusService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BulkActionsSdkStatusService,
    factory: BulkActionsSdkStatusService.ɵfac,
    providedIn: 'root'
  });
  return BulkActionsSdkStatusService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function fillMissingValues(resp) {
  return resp.map(v => {
    v.processedItems = v.processedItems || 0;
    v.totalItems = v.totalItems || 0;
    return v;
  });
}

/**
 * Generated bundle index. Do not edit.
 */

export { ActionList, ActionListKey, ActionListsApiService, ActionListsSdkService, AddActionListItemsRequest, AddMultiStaticItemRequest, AddStaticItemRequest, BulkActionInstance, BulkActionInstanceStatus, BulkActionStatusApiService, BulkActionsApiService, BulkActionsSdkStatusService, BulkAddStaticItemsRequest, BulkProcessorApiService, BulkProcessorDetails, BulkProcessorDetailsCSVFile, BulkProcessorDetailsImportUsers, BulkProcessorDetailsScheduleCampaign, BulkProcessorDetailsScheduleCampaignSender, BulkProcessorDetailsUserList, BulkProcessorSdkService, BulkProcessorType, ComputeActionListIDsRequest, ComputeActionListIDsResponse, ComputeActionListIDsResponseNameIdMappingEntry, CreateActionListRequest, CreateActionListResponse, CreateListDefinitionRequest, CreateListDefinitionResponse, DateDefault, DeleteActionListRequest, DeleteListDefinitionRequest, DeleteStaticItemRequest, FieldMask, Filter, FilterGroup, FilterGroupOperator, FilterOperator, FilterType, FilterValue, GenerateUploadSignedURLRequest, GenerateUploadSignedURLResponse, GetActionListItemIDsRequest, GetActionListItemIDsResponse, GetBulkActionInstanceItemIDsRequest, GetBulkActionInstanceItemIDsResponse, GetMultiListDefinitionRequest, GetMultiListDefinitionResponse, HostService, InitiateBulkActionRequest, InitiateBulkProcessorRequest, InitiateBulkProcessorResponse, ListBulkActionStatusesForActionListRequest, ListBulkActionStatusesForActionListResponse, ListDefinition, ListDefinitionsApiService, ListDefinitionsRequest, ListDefinitionsResponse, ListItem, ListItemsApiService, ListItemsRequest, ListItemsResponse, ListType, ObjectSearch, PagedRequestOptions, PagedResponseMetadata, Phone, RemoveActionListItemsRequest, StartManualAutomationsRequest, StartManualAutomationsRequestStartAutomationPayload, UpdateListDefinitionRequest, ValidateFileRequest, ValidateFileResponse };
